export default __webpack_public_path__ + "static/media/GreenBeans.0bd5f007.jpg";